module.exports = __webpack_public_path__ + "img/upgradeManage.654d8d67.svg";